/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { Icon } from '@salesforce/design-system-react';
import PropTypes from 'prop-types';
import React from 'react';
import { ProvisionedCard } from '../../homepage-card';

import CardFooter from '../../card-footer';
import RecentlyEditedEmail from './item';
import UnprovisionedEmailStudio from '../unprovisioned/unprovisioned-email-studio';

const emailIcon = <Icon category="custom" name="custom105" size="small" style={{ backgroundColor: '#f0b31d' }} />;

function handleDeepLink(onDeepLink, email) {
  if (onDeepLink) {
    let link;

    if (email && email.legacyId) {
      link = `/C12/Default.aspx?entityType=email&entityID=${email.legacyId}&action=update`;
    }

    onDeepLink({
      appName: 'Email',
      analyticsName: 'Recently Edited Email',
      link,
    });
  }
}

function RecentlyEditedEmailsCard({ className, editedEmails, localizations, onDeepLink, unprovisioned }) {
  return (
    <div>
      {unprovisioned ? (
        <UnprovisionedEmailStudio
          className={className}
          heading={localizations['homepage.cards.recently_edited_emails.heading']}
          icon={emailIcon}
          localizations={localizations}
        />
      ) : (
        <ProvisionedCard
          className={className}
          heading={localizations['homepage.cards.recently_edited_emails.heading']}
          icon={emailIcon}
          forceShowFooter
          footer={<CardFooter onClick={() => handleDeepLink(onDeepLink)} />}
        >
          {editedEmails && editedEmails.length > 0 ? (
            <ul className="slds-has-dividers--bottom-space">
              {editedEmails.map((email) => (
                <RecentlyEditedEmail
                  {...email}
                  key={email.id}
                  localizations={localizations}
                  onClick={() => handleDeepLink(onDeepLink, email)}
                />
              ))}
            </ul>
          ) : (
            <div className="slds-text-align--center slds-text-heading--medium" style={{ marginTop: '104px' }}>
              {localizations['homepage.cards.recently_edited_emails.no_recent']}
            </div>
          )}
        </ProvisionedCard>
      )}
    </div>
  );
}

RecentlyEditedEmailsCard.displayName = 'Recently Edited Emails Card';

RecentlyEditedEmailsCard.propTypes = {
  className: PropTypes.string,
  editedEmails: PropTypes.array,
  localizations: PropTypes.object,
  onDeepLink: PropTypes.func,
  unprovisioned: PropTypes.bool,
};

export default RecentlyEditedEmailsCard;
